import { computed, ref, type Ref } from "vue";
import type { House, HouseListItem } from "./types";

export type Query = {
  search: string;
  withDetails: boolean | null;
};

export function useFilter(houses: Ref<Array<HouseListItem> | undefined>) {
  const query: Ref<Query> = ref({
    search: "",
    withDetails: true,
  });

  const hasDetails = (house: House): boolean => {
    return (
      house.numberOfFloors != null ||
      house.numberOfDoors != null ||
      house.yearBuilt != null ||
      house.heatingType != null ||
      house.owner != null ||
      house.tags.length > 0
    );
  };

  const filteredHouses = computed(() => {
    if (houses.value === undefined) return [];

    return houses.value.filter((house) => {
      if (query.value.withDetails === true && !hasDetails(house)) return false;
      if (query.value.withDetails === false && hasDetails(house)) return false;

      const address = [house.street, house.houseNumber].join(" ").toLowerCase();
      return address.includes(query.value.search.trim().toLowerCase());
    });
  });

  return { query, filteredHouses, hasDetails };
}
